import React from "react";
import { DDD_DD_MMM_YYYY_HH_MM_SS_A, TIME_ZONE } from "../../../utils/const";
import Moment from "react-moment";
import UniversalViewModal from "../../Modal/UniversalViewModal";
import "moment-timezone";

export function UserReceiptModal({ data, handleConfirmHide, isConfirmModal }) {
  const {
    id,
    firstname,
    lastname,
    email,
    cellnumber,
    social_signin,
    username,
    business_name,
    account_number,
    address_1,
    address_2,
    zip_code,
    country,
    state,
    city,
    deleted_at,
    last_transaction_date,
    createdAt,
  } = data;

  const dataArray = [];

  const renderUserName = () => {
    let name = "";
    if (firstname) name = name.concat(`${firstname}`);
    if (lastname) name = name.concat(` ${lastname}`);
    return <span className="text-capitalize">{name}</span>;
  };

  const renderLastTransactionDate = (date) => {
    if (!data) return "";
    return (
      <Moment date={date} format={DDD_DD_MMM_YYYY_HH_MM_SS_A} tz={TIME_ZONE} />
    );
  };

  const renderUserAddress = () => {
    const { name: cityName } = city || {};
    const { state_name: stateName } = state || {};
    const { name: countryName } = country || {};

    let address = "";
    if (address_1) address = address.concat(`${address_1}, `);
    if (address_2) address = address.concat(`${address_2}, `);
    if (cityName) address = address.concat(`${cityName}, `);
    if (stateName) address = address.concat(`${stateName}, `);
    if (countryName) address = address.concat(`${countryName}, `);
    if (zip_code) address = address.concat(`${zip_code}`);
    return address === "" ? (
      "-"
    ) : (
      <span className="text-capitalize">{address}</span>
    );
  };

  const renderJoiningDate = () => {
    if (!createdAt) return "-";
    return (
      <Moment
        date={createdAt}
        format={DDD_DD_MMM_YYYY_HH_MM_SS_A}
        tz={TIME_ZONE}
      />
    );
  };

  const renderUserStatus = () => {
    let statusClass = "";
    statusClass = deleted_at ? "status-rejected" : "status-success";
    return (
      <span className={`${statusClass} status-color text-capitalize`}>
        {deleted_at ? "Yes" : "No"}
      </span>
    );
  };

  if (account_number) {
    dataArray.push({ key: "Account Number", value: account_number });
  }
  if (firstname && lastname) {
    dataArray.push({ key: "Name", value: renderUserName() });
  }
  if (account_number) {
    dataArray.push({ key: "Email", value: email });
  }
  if (cellnumber) {
    dataArray.push({ key: "Phone Number", value: cellnumber });
  }
  if (username) {
    dataArray.push({ key: "Username", value: username });
  }
  if (business_name) {
    dataArray.push({ key: "Business Name", value: business_name });
  }
  if (last_transaction_date) {
    dataArray.push({
      key: "Last Transaction date",
      value: renderLastTransactionDate(last_transaction_date),
    });
  }

  if (address_1 || address_2 || city || state || country || zip_code) {
    dataArray.push({
      key: "Address",
      value: renderUserAddress(),
    });
  }

  if (createdAt) {
    dataArray.push({
      key: "Joining Date",
      value: renderJoiningDate(),
    });
  }

  // TODO Replace social signin with content like google and facebook
  dataArray.push({
    key: "Login Via",
    value: social_signin ? social_signin : "-",
  });

  // dataArray.push({
  //   key: "is User Deleted?",
  //   value: renderUserStatus(),
  // });

  // TODO Add User's Bank Details

  return (
    <>
      <UniversalViewModal
        handleConfirmHide={handleConfirmHide}
        isConfirmModal={isConfirmModal}
        title={`View User Details - ${firstname} ${lastname}`}
        dataArray={dataArray}
      />
    </>
  );
}
